export interface StripeProduct {
  id: string;
  priceId: string;
  name: string;
  description: string;
  mode: 'payment' | 'subscription';
  price: number; // in cents
  currency: string;
  interval?: 'month' | 'year';
}

export const STRIPE_PRODUCTS: StripeProduct[] = [
  {
    id: 'prod_SYZPeL1ZrFDFBK',
    priceId: 'price_1RdSGNDeJBkICjwzFrnDLUPF',
    name: 'Pro Plan',
    description: 'Up to 10 rooms simultaneously. Maximum 50 participants per room. 5 broadcast links per room. 10 API keys. Priority email support',
    mode: 'subscription',
    price: 400, // €4.00 in cents
    currency: 'eur',
    interval: 'month'
  },
  {
    id: 'prod_SYZP9ASUZNNxpG',
    priceId: 'price_1RdSGsDeJBkICjwzf5xmXDe5',
    name: 'Enterprise Plan',
    description: 'Unlimited rooms. Maximum 200 participants per room. Unlimited broadcast links. Advanced security features. 24/7 dedicated support. Custom domain & SSO. SLA guarantee',
    mode: 'subscription',
    price: 600, // €6.00 in cents
    currency: 'eur',
    interval: 'month'
  }
];

export const getProductById = (id: string): StripeProduct | undefined => {
  return STRIPE_PRODUCTS.find(product => product.id === id);
};

export const getProductByPriceId = (priceId: string): StripeProduct | undefined => {
  return STRIPE_PRODUCTS.find(product => product.priceId === priceId);
};

export const formatPrice = (price: number, currency: string): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(price / 100);
};